var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", [
    _c("label", [_vm._v(_vm._s(_vm.fieldLabel))]),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.buffer, function (entry, idx) {
        return _c("li", { key: _vm.fieldName + idx, class: _vm.fieldType }, [
          _vm.showStepNumber
            ? _c("div", { staticClass: "step-number" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(parseInt(idx) + 1) +
                    "\n            "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.fieldType === "text"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.buffer[idx],
                    expression: "buffer[idx]",
                  },
                ],
                ref: "list-field",
                refInFor: true,
                attrs: { type: "text" },
                domProps: { value: _vm.buffer[idx] },
                on: {
                  keyup: _vm.keyPressed,
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.buffer, idx, $event.target.value)
                    },
                    _vm.handleInput,
                  ],
                  paste: _vm.handlePaste,
                },
              })
            : _vm.fieldType === "textarea"
            ? _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.buffer[idx],
                    expression: "buffer[idx]",
                  },
                ],
                ref: "list-field",
                refInFor: true,
                domProps: { value: _vm.buffer[idx] },
                on: {
                  keyup: _vm.keyPressed,
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.buffer, idx, $event.target.value)
                    },
                    _vm.handleInput,
                  ],
                  paste: _vm.handlePaste,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "controls" }, [
            _c("button", {
              staticClass: "icon-arrow-up",
              attrs: { title: _vm.t("cookbook", "Move entry up") },
              on: {
                click: function ($event) {
                  return _vm.moveEntryUp(idx)
                },
              },
            }),
            _vm._v(" "),
            _c("button", {
              staticClass: "icon-arrow-down",
              attrs: { title: _vm.t("cookbook", "Move entry down") },
              on: {
                click: function ($event) {
                  return _vm.moveEntryDown(idx)
                },
              },
            }),
            _vm._v(" "),
            _c("button", {
              staticClass: "icon-add",
              attrs: { title: _vm.t("cookbook", "Insert entry above") },
              on: {
                click: function ($event) {
                  return _vm.addNewEntry(idx)
                },
              },
            }),
            _vm._v(" "),
            _c("button", {
              staticClass: "icon-delete",
              attrs: { title: _vm.t("cookbook", "Delete entry") },
              on: {
                click: function ($event) {
                  return _vm.deleteEntry(idx)
                },
              },
            }),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button add-list-item",
        on: {
          click: function ($event) {
            return _vm.addNewEntry()
          },
        },
      },
      [
        _c("span", { staticClass: "icon-add" }),
        _vm._v(" " + _vm._s(_vm.t("cookbook", "Add")) + "\n    "),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }